import React from 'react';

export interface EmbeddedSurveyEditorContextType {
  /** When set, indicates the survey editor is embedded (e.g. inside a modal). */
  isEmbedded: true;
  /** Close the embedding container (e.g. the modal). */
  onClose: () => void;
}

const EmbeddedSurveyEditorContext = React.createContext<EmbeddedSurveyEditorContextType | null>(
  null,
);

export const EmbeddedSurveyEditorProvider = EmbeddedSurveyEditorContext.Provider;

export const useEmbeddedSurveyEditor = () => React.useContext(EmbeddedSurveyEditorContext);
